import type { NextEditorPlugin } from '@atlaskit/editor-common/types/next-editor-plugin';
import { isEmptyDocument } from '@atlaskit/editor-common/utils';

export const emptyStatePlugin: NextEditorPlugin<
	'empty',
	{ sharedState: { editorIsEmpty: boolean } | undefined }
> = () => ({
	name: 'empty',
	getSharedState(editorState) {
		if (!editorState) {
			return undefined;
		}
		return {
			editorIsEmpty: isEmptyDocument(editorState.doc),
		};
	},
});
